import React from "react";
import { FaLinkedin } from "react-icons/fa";
import "./TeamSection.css";
import member1 from "../../assets/rajnikanth.png";
import member2 from "../../assets/Karan R Sheth.png";
import member3 from "../../assets/Sagar.png";

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Rajnikant C Sheth",
      role: "Founder and Managing Partner",
      description:
        "Rajnikant C Sheth is the visionary founder and driving force behind our success. He has built a legacy grounded in innovation, trust, and people-first values. Rajnikant Sheth leads with quiet strength, empowering others while staying deeply rooted in humility — a rare combination that continues to inspire professionals across generations.",
      img: member1,
      linkedin: "", 
    },
    {
      id: 2,
      name: "Karan R Sheth",
      role: "Managing Partner",
      description:
        "Karan Sheth is a driven and forward-thinking Managing Partner, known for his sharp business acumen and a relentless pursuit of innovation. Despite his impressive achievements, he remains grounded and approachable, earning the respect of his peers through his humility, collaborative leadership style, and unwavering commitment to excellence.",
      img: member2,
      linkedin: "https://www.linkedin.com/in/karan-sheth-3904a03?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    {
      id: 3,
      name: "Sagar R Sheth",
      role: "Managing Partner",
      description:
        "Sagar Sheth is a dynamic Managing Partner known for his relentless drive, sharp strategic mindset, and aggressive pursuit of success. His high-energy approach and commitment to excellence consistently push boundaries and deliver impactful outcomes.",
      img: member3,
      linkedin: "https://www.linkedin.com/in/sagar-sheth-5794bb49?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
  ];

  return (
    <section className="custom-team-section">
      <div className="custom-team-header">
        <h5 className="custom-team-subtitle">The Visionaries</h5>
        <h2 className="custom-team-title">Founder and Partners</h2>
      </div>

      <div className="custom-team-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="custom-team-card">
            <img
              src={member.img}
              alt={member.name}
              className="custom-team-image"
            />
            <div className="custom-team-info">
              <h3 className="custom-team-name">{member.name}</h3>
              <p className="custom-team-role">{member.role}</p>
              <p className="custom-team-description">{member.description}</p>
            </div>

            {/* 👇 Show LinkedIn icon only if link exists */}
            {member.linkedin && (
              <div className="custom-team-icons">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="custom-linkedin-icon"
                >
                  <FaLinkedin />
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
